import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import api from 'services';
import type { ApiError } from 'services/api.errors';
import type { ProfileResponse } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetProfile = () => {
  const [canGetProfile, setCanGetProfile] = useState<boolean>(!!api.accessToken);

  const queryKey = QueryKeys.profile;

  const queryFn = async () => {
    const { data } = await api.getProfile();
    return data;
  };

  const onStorageAdd = () => {
    setCanGetProfile(true);
  };

  const onStorageClear = () => {
    setCanGetProfile(false);
  };

  useEffect(() => {
    window.addEventListener('storageAdd', onStorageAdd);
    window.addEventListener('storageClear', onStorageClear);
    return () => {
      window.removeEventListener('storageAdd', onStorageAdd);
      window.removeEventListener('storageClear', onStorageClear);
    };
  }, []);

  return useQuery<ProfileResponse, AxiosError<ApiError, string>>(queryKey, queryFn, {
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: canGetProfile,
    staleTime: 10000,
  });
};
